import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

// shared
import authUser from "@/app/stores/modules/_shared/auth-user";
import sideBar from "@/app/stores/modules/_shared/sidebar";
import lmdcUser from "@/app/stores/modules/_shared/lmdc-user";
import preFilters from "@/app/stores/modules/_shared/pre-filters";
import group from "@/app/stores/modules/_shared/group";
import notification from "@/app/stores/modules/_shared/notification";
import breeds from "@/app/stores/modules/_shared/breeds";
import dogPurchase from "@/app/stores/modules/_shared/dog-purchase";
import breeder from "@/app/stores/modules/_shared/breeder.js";
import puppySell from "@/app/stores/modules/_shared/puppy-sell.js";
import subscriptionFilters from "@/app/stores/modules/_shared/subscription-filters";
import treatmentFilters from "@/app/stores/modules/_shared/treatment-filters.js";
import breederPuppyListFilters from "@/app/stores/modules/_shared/breeder-puppy-list-filters.js";
import breederLitterManagementFilters from "@/app/stores/modules/_shared/breeder-litter-management-filters.js";
import breederMatingListFilters from "@/app/stores/modules/_shared/breeder-mating-list-filters.js";
import breederDamSireListFilters from "@/app/stores/modules/_shared/breeder-dam-sire-list-filters.js";

const ls = new SecureLS({ isCompression: false });
Vue.use(Vuex);
export default new Vuex.Store({
    plugins: [
        createPersistedState({
            paths: ["lmdcUser", "group", "breeds"],
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key),
            },
        }),
    ],
    modules: {
        // shared
        authUser,
        lmdcUser,
        sideBar,
        preFilters,
        group,
        notification,
        breeds,
        dogPurchase,
        breeder,
        puppySell,
        subscriptionFilters,
        treatmentFilters,
        breederPuppyListFilters,
        breederLitterManagementFilters,
        breederMatingListFilters,
        breederDamSireListFilters
    },
});
